<template>
  <div id="app">
    <Navbar v-on:click="resetData()" />
    <b-container fluid>
      <b-row
        class="align-content-start align-content-lg-center align-items-center h-100"
        align-h="center"
      >
        <b-col cols="12" v-if="step === 0">
          <Home v-on:click="step = 1" />
        </b-col>
        <b-col order-lg="2" cols="12" lg="3" v-if="step > 0 && !hideStepper">
          <Stepper
            :step="step"
            :office="officeName"
            :name="userName"
            :date="date"
            :appointmentType="appointmentType"
            :displayOfficeChoice="displayOfficeChoice"
            v-on:update="step = $event"
          />
        </b-col>
        <b-col lg="9" xl="8" v-if="step > 0">
          <transition name="fade" mode="out-in">
            <AppointmentType
              v-on:update="selectAppointmentType"
              v-if="step === 1"
            />
            <OfficeChoice
              v-on:update="selectOffice"
              v-if="displayOfficeChoice && step === 2"
            />
            <Identification
              :user="userData"
              v-on:update="storeUserData"
              v-if="
                (!displayOfficeChoice && step === 2) ||
                (displayOfficeChoice && step === 3)
              "
            />
            <Appointment
              :office="selectedOffice"
              :action="appointmentType"
              v-on:update="selectAppointment"
              v-if="
                (!displayOfficeChoice && step === 3) ||
                (displayOfficeChoice && step === 4)
              "
            />
            <Summary
              v-on:done="send"
              :office="selectedOffice"
              :appointment="selectedAppointment"
              :isDone="isDone"
              v-if="
                (!displayOfficeChoice && step === 4) ||
                (displayOfficeChoice && step === 5)
              "
            />
          </transition>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="text-center py-2"
      ><a
        href="https://teo-lesite.com/"
        class="text-muted"
        target="_blank"
        rel="noopener"
        >Un service TéO</a
      ></b-container
    >
  </div>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Home from "./components/Home.vue";
import OfficeChoice from "./components/OfficeChoice.vue";
import Identification from "./components/Identification.vue";
import AppointmentType from "./components/AppointmentType.vue";
import Appointment from "./components/Appointment.vue";
import Summary from "./components/Summary.vue";
import Stepper from "./components/Stepper.vue";
import moment from "moment";
import { createAppointmentAsync } from "./api/dossierApi";
import * as Sentry from "@sentry/vue";

export default {
  name: "App",
  components: {
    Navbar,
    Home,
    OfficeChoice,
    Identification,
    Appointment,
    Summary,
    Stepper,
    AppointmentType,
  },
  data() {
    return {
      step: 0,
      steps: [],
      appointmentType: null,
      userData: {},
      selectedOffice: {},
      userName: "",
      officeName: "",
      date: "",
      hideStepper: false,
      isDone: false,
    };
  },

  computed: {
    officeList() {
      return this.$root.slugData.offices;
    },
    displayOfficeChoice() {
      return this.officeList.length > 1;
    }
  },

  watch: {
    officeList() {
      this.selectedOffice = this.officeList[0];
    }
  },

  methods: {
    resetData() {
      if (this.isDone) {
        location.reload();
        return;
      }
      this.step = 0;
    },

    storeUserData(data) {
      this.userData = data;
      this.userName = data.firstname + " " + data.lastname;
      if (this.displayOfficeChoice) this.step = 4;
      else this.step = 3;
    },

    selectOffice(data) {
      this.selectedOffice = data;
      this.officeName = data.name;
      this.step = 3;
    },

    selectAppointment(data) {
      this.selectedAppointment = data;
      this.date = moment(data.appointment.start)
        .locale("fr")
        .format("dddd Do MMMM YYYY à H[h]mm");
      if (this.displayOfficeChoice) this.step = 5;
      else this.step = 4;
    },

    selectAppointmentType(value) {
      this.appointmentType = value;
      this.step = 2;
    },

    async send() {
      this.isDone = false;
      let model = {
        dossierId: this.userData.dossierId ?? null,
        firstName: this.userData.firstname,
        lastName: this.userData.lastname,
        phone: [
          {
            number: this.userData.phone.number,
            isMobile: this.userData.phone.mobile,
          },
        ],
        email: this.userData.email,
        consultantId: this.selectedAppointment.appointment.consultantId,
        activityId: this.selectedAppointment.appointment.id,
        locationId: this.selectedOffice?.id ?? null,
        distancial: this.selectedAppointment.distancial,
      };
      try {
        await createAppointmentAsync(model, this.$root.slug);
        this.hideStepper = true;
        this.isDone = true;
      } catch (e) {
        Sentry.captureException(e);
        this.isDone = null;
      }
    },
  },
};
</script>

<style lang="scss">
@import "./assets/scss/styles.scss";

#app {
  height: 100%;
  width: 100%;
  display: flex;
  flex-flow: column;
}

#app > :nth-child(2) {
  flex: 1 0 auto;
}
</style>
